function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#flag-en_svg__filter0_d_719_5306)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#flag-en_svg__clip0_719_5306)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 4.25h27v18H4v-18z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 4.25h27v1.384H4V4.25zm0 2.768h27v1.385H4V7.018zm0 2.769h27v1.384H4V9.787zm0 2.768h27v1.385H4v-1.385zm0 2.774h27v1.384H4V15.33zm0 2.768h27v1.385H4v-1.385zm0 2.769h27v1.384H4v-1.384z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 4.25h13.5v9.69H4V4.25z",
  fill: "#2E52B2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.516 11.56l-.21-.673-.232.673h-.695l.563.406-.21.674.573-.416.558.415-.216-.673.574-.405h-.705zm2.963 0l-.216-.673-.22.673h-.696l.563.406-.21.674.563-.416.569.415-.211-.673.563-.405H9.48zm2.974 0l-.227-.673-.21.673h-.71l.578.406-.22.674.562-.416.58.415-.222-.673.563-.405h-.694zm2.958 0l-.211-.673-.221.673h-.7l.568.406-.21.674.563-.416.568.415-.226-.673.579-.405h-.71zM9.263 8.213l-.22.674h-.696l.563.416-.21.663.563-.41.569.41-.211-.663.563-.416H9.48l-.216-.674zm-2.958 0l-.231.674h-.695l.563.416-.21.663.573-.41.558.41-.216-.663.574-.416h-.705l-.21-.674zm5.921 0l-.21.674h-.71l.578.416-.22.663.562-.41.58.41-.222-.663.563-.416h-.694l-.227-.674zm2.974 0l-.221.674h-.7l.568.416-.21.663.563-.41.568.41-.226-.663.579-.416h-.71l-.211-.674zM6.305 5.55l-.231.663h-.695l.563.416-.21.668.573-.415.558.415-.216-.668.574-.416h-.705l-.21-.663zm2.958 0l-.22.663h-.696l.563.416-.21.668.563-.415.569.415-.211-.668.563-.416H9.48l-.216-.663zm2.963 0l-.21.663h-.71l.578.416-.22.668.562-.415.58.415-.222-.668.563-.416h-.694l-.227-.663zm2.974 0l-.221.663h-.7l.568.416-.21.668.563-.415.568.415-.226-.668.579-.416h-.71L15.2 5.55z",
  fill: "#fff"
})));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "flag-en_svg__clip0_719_5306"
}, /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4.25,
  width: 27,
  height: 18,
  rx: 2,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "flag-en_svg__filter0_d_719_5306",
  x: 0,
  y: 0.25,
  width: 35,
  height: 26,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_719_5306"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_719_5306",
  result: "shape"
})));

function SvgFlagEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgFlagEn;